import request from '@/utils/request'

/**
 * 获取资讯详情
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listInformation(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/information.listInformation',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取其他资讯列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listInformationOther(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/information.listInformationOther',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}